<template>
  <div class="nav-bar" :class="{home: $store.state.scrollTop < 100 && $store.state.selected.indexOf('Home') > -1}" ref="nav-bar">
    <div class="logo" @click="navigation({name: 'Home'})">
      <img src="@/assets/nav-bar/logo.png" alt="">
    </div>
    <div class="item" :class="{selected: $store.state.selected.indexOf('Home') > -1}" @click="navigation({name: 'Home'})">
      <div class="text">首页</div>
      <div class="item-border"></div>
    </div>
    <div class="item" :class="{selected: $store.state.selected.indexOf('Server') > -1}" @click="navigation({name: 'Server'})">
      <div class="text">服务介绍</div>
      <div class="item-border"></div>
      <div class="list animate__animated animate__fadeIn">
        <div class="i" @click.stop="navigation({name: 'Server', query: {selected: 'TOP'}})">运营模式</div>
        <div class="i" @click.stop="navigation({name: 'Server', query: {selected: 'EP'}})">入场准备</div>
        <div class="i" @click.stop="navigation({name: 'Server', query: {selected: 'PA'}})">平台优势</div>
      </div>
    </div>
    <div class="item" :class="{selected: $store.state.selected.indexOf('Product') > -1}" @click="navigation({name: 'Product'})">
      <div class="text">产品介绍</div>
      <div class="item-border"></div>
      <div class="list animate__animated animate__fadeIn">
        <div class="i" @click.stop="navigation({name: 'Product', query: {selected: 0}})">产品</div>
        <div class="i" @click.stop="navigation({name: 'Product', query: {selected: 1}})">iDAS</div>
        <div class="i" @click.stop="navigation({name: 'Product', query: {selected: 2}})">自主硬件研发</div>
      </div>
    </div>
    <div class="item" :class="{selected: $store.state.selected.indexOf('About') > -1}" @click="navigation({name: 'About'})">
      <div class="text">关于我们</div>
      <div class="item-border"></div>
      <div class="list animate__animated animate__fadeIn">
        <div class="i" @click.stop="navigation({name: 'About', query: {selected: 0}})">企业介绍</div>
        <!-- <div class="i" @click.stop="navigation({name: 'About', query: {selected: 1}})">工作机会</div> -->
        <div class="i" @click.stop="navigation({name: 'About', query: {selected: 2}})">联系我们</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'nav-bar',
  data () {
    return {

    }
  },
  mounted () {

  },
  methods: {
    /**
     * 页面跳转
     */
    navigation (url) {
      this.$router.push(url)
    }
  }
}
</script>
<style scoped>
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 120rem;
  z-index: 10;
  font-size: 1.4rem;
  line-height: 1.4rem;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  transition: all 0.5s;
  padding: 0rem 23rem;
  box-shadow: 0px 0px 2rem 0px rgba(171, 180, 200, 0.3);
}
.home.nav-bar {
  background-color: transparent;
  color: #FFFFFF;
  padding: 3.4rem 6.3rem;
  box-shadow: none;
}
.logo {
  width: 6.5rem;
  min-width: 6.5rem;
  padding-right: 5.7rem;
  transition: all 0.5s;
}
.home .logo {
  width: 14rem;
  min-width: 14rem;
  padding-right: 13rem;
}
.item {
  margin: 0 3rem;
  padding: 2rem 3rem;
  font-size: 1.4rem;
  white-space: nowrap;
  position: relative;
}
.home .item {
  padding: 0rem 3rem;
}
.item.selected {
  color: #FF8C33;
  font-weight: bolder;
}
.item-border {
  width: 3rem;
  border-radius: 0.2rem;
  height: 0.4rem;
  margin: 0 auto;
  margin-top: 0.5rem;
}
.home .item-border {
  margin-top: 1rem;
}
.item.selected .item-border {
  background-color: #FF8C33;
}
.item .list {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: -1;
  width: 100%;
  color: #434343;
  background-color: #FFFFFF;
  display: none;
  transition: all 0.5s;
  box-shadow: 0px 5px 5px 0px rgba(171, 180, 200, 0.3);
  font-weight: normal;
}
.item:hover .list {
  z-index: 11;
  display: block;
}
.item:hover .item-border {
  background-color: #FF8C33;
}
.item .list .i {
  line-height: 3.5rem;
}
.item .list .i:hover {
  color: #FF8C33;
}
.home .item .list {
  display: none;
}
.home .item:hover .item-border {
  background-color: transparent;
}
</style>
